import { useAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import { timezone as timezoneOptions } from '@/lib/settings/optionsConfiguration/platformSettings/timezone';

// Components
import { SelectFilterComponent } from '@/components/base/SelectFilter/SelectFilterComponent';
// Atoms
import { deadlineTimezoneAtom } from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms/index';

export const TimezoneSection = () => {
    const { t } = useTranslation('giveaway_picker');
    const [deadlineTimezone, setDeadlineTimezone] = useAtom(deadlineTimezoneAtom);

    const handleTimezoneChange = (timezone: (typeof timezoneOptions)[number]) => {
        setDeadlineTimezone(timezone.value);
    };

    return (
        <span className="w-2/4">
            <span className="mb-1.5 inline-block font-GMedium text-xs text-icoGray-400">
                {t('options.deadline_group.select_timezone')}
            </span>
            <SelectFilterComponent
                className="max-w-full"
                selected={timezoneOptions.find((item) => item?.value === deadlineTimezone)}
                buttonVariant="lightBorder"
                setSelected={handleTimezoneChange}
                required
                options={timezoneOptions}
            />
        </span>
    );
};
